"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobileStylesHelper_1 = __importDefault(require("../assets/mobileStylesHelper"));

var styles = function styles(_a) {
  var colorBgSecondary = _a.colorBgSecondary,
      sizeControlHeight = _a.sizeControlHeight,
      colorBg = _a.colorBg,
      sizeBorderWidth = _a.sizeBorderWidth,
      sizeBorderRadius = _a.sizeBorderRadius,
      colorIcon = _a.colorIcon,
      x6 = _a.x6;
  return __assign(__assign({
    select: {
      position: 'relative',
      '& .Select-control $inline': {
        display: 'inline-block'
      },
      '& .Select-control .Select-clear-zone': {
        display: 'none'
      },
      '& .Select-control': {
        margin: 0,
        position: 'relative',
        boxSizing: 'border-box',
        cursor: 'pointer'
      },
      '&:not($inline):not($link) .Select-multi-value-wrapper': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        'white-space': 'nowrap'
      },
      '& .Select-multi-value-wrapper': {
        display: 'block'
      },
      '& .Select-value': {
        display: 'inline'
      },
      '&$link .Select-value, &$secondary&$link .Select-placeholder': {
        textDecoration: 'underline'
      },
      '&.is-open .Select-value, &:hover .Select-value, ': {
        textDecoration: 'none'
      },
      '& .Select-value-icon': {
        display: 'none'
      },
      '& .Select-arrow-zone svg': {
        display: 'block',
        position: 'absolute',
        right: '3px',
        top: '0',
        bottom: '0',
        margin: 'auto 0',
        fill: colorIcon.normal
      },
      '&$link .Select-arrow-zone svg': {
        display: 'none'
      },
      '& .Select-input': {
        position: 'absolute'
      },
      '&$secondary:not($link)': {
        backgroundColor: colorBgSecondary
      },
      '&$secondary:not($link) .Select-control': {
        lineHeight: '24px',
        height: '24px',
        padding: '0 23px 0 8px'
      },
      '&:not($link):not($secondary) .Select-control': {
        padding: '0 29px 0 12px',
        borderRadius: sizeBorderRadius,
        background: colorBg,
        lineHeight: sizeControlHeight - 2 * sizeBorderWidth + "px",
        height: sizeControlHeight - 2 * sizeBorderWidth
      }
    },
    smallSelect: {
      lineHeight: x6 + "px",
      height: x6 + "px",
      '& .Select-multi-value-wrapper': {
        lineHeight: x6 + "px",
        height: x6 + "px"
      },
      '&:not($link):not($secondary) .Select-control': {
        lineHeight: x6 + "px",
        height: x6 + "px"
      }
    },
    disableDelimiter: {
      '& .Select-aria-only': {
        display: 'none'
      }
    }
  }, mobileStylesHelper_1.default({
    '& .Select-control': {
      lineHeight: '46px',
      height: '46px'
    }
  })), {
    inline: {},
    link: {},
    secondary: {}
  });
};

exports.default = styles;